import { render, staticRenderFns } from "./ChangeTables.vue?vue&type=template&id=1bf11e4a&scoped=true"
import script from "./ChangeTables.vue?vue&type=script&lang=js"
export * from "./ChangeTables.vue?vue&type=script&lang=js"
import style0 from "./ChangeTables.vue?vue&type=style&index=0&id=1bf11e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf11e4a",
  null
  
)

export default component.exports